const BUYER_NOTIFICATION = [
	{
		title: 'General notifications',
		description: "Select when you'll be notified when the following changes occur.",
		items: [
			{
				title: 'Someone replies to any message',
				inApp: false,
				email: false,
			},
			{
				title: "I'm assigned a task",
				inApp: false,
				email: false,
			},
			{
				title: 'A task is overdue',
				inApp: false,
				email: false,
			},
			{
				title: 'A task status is updated',
				inApp: false,
				email: false,
			},
		],
	},
	{
		title: 'System notifications',
		description: "Select when you'll be notified when the following changes occur.",
		items: [
			{
				title: 'Newsletter Update',
				inApp: false,
				email: false,
			},
			{
				title: 'New Promotion',
				inApp: false,
				email: false,
			},
			{
				title: 'Web Maintenance',
				inApp: false,
				email: false,
			},
		],
	},
]

export default BUYER_NOTIFICATION
